import { render, staticRenderFns } from "./a-input.vue?vue&type=template&id=ca2a0074&scoped=true&"
import script from "./a-input.vue?vue&type=script&lang=js&"
export * from "./a-input.vue?vue&type=script&lang=js&"
import style0 from "./a-input.vue?vue&type=style&index=0&id=ca2a0074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2a0074",
  null
  
)

export default component.exports